/**
 * Document URL Helper Utilities
 * Centralized functions for handling document URLs
 */

/**
 * Constructs full URLs for document HTML and PDF
 * @param {Object} data - Response data containing htmlUrl and pdfUrl
 * @param {string} data.htmlUrl - Relative HTML URL
 * @param {string} data.pdfUrl - Relative PDF URL (optional)
 * @returns {Object} Object with full htmlUrl and pdfUrl
 */
export const getDocumentUrls = (data) => {
  const baseUrl = process.env.REACT_APP_MAIN_BASE_URL || '';
  
  return {
    htmlUrl: data.htmlUrl ? `${baseUrl}${data.htmlUrl}` : null,
    pdfUrl: data.pdfUrl ? `${baseUrl}${data.pdfUrl}` : null,
  };
};

/**
 * Creates URL search params for document viewer navigation
 * @param {Object} params - Parameters for document viewer
 * @param {string} params.htmlUrl - Full HTML URL
 * @param {string} params.pdfUrl - Full PDF URL (optional)
 * @param {string} params.documentNumber - Document number
 * @param {string} params.documentType - Document type (e.g., "Sale Bill", "Voucher")
 * @returns {string} URL search params string
 */
export const createDocumentViewerParams = ({ htmlUrl, pdfUrl, documentNumber, documentType }) => {
  const params = new URLSearchParams({
    htmlUrl: htmlUrl || '',
    pdfUrl: pdfUrl || '',
    number: documentNumber || '',
    type: documentType || 'Document'
  });
  
  return params.toString();
};

/**
 * Gets document viewer route with params
 * @param {string} documentId - Document ID
 * @param {Object} params - Document viewer parameters
 * @returns {string} Full route path with query params
 */
export const getDocumentViewerRoute = (documentId, params) => {
  const queryString = createDocumentViewerParams(params);
  return `/document-viewer/${documentId}?${queryString}`;
};

/**
 * Builds the ledger report page route with auto-submit query params.
 */
export const getLedgerPageRoute = ({
  accountId,
  fromdate,
  todate,
  isGroup = false,
}) => {
  const params = new URLSearchParams({
    auto: "1",
    fromdate: fromdate || "",
    todate: todate || "",
  });

  if (isGroup) {
    params.set("accgrp", accountId);
  } else {
    params.set("account", accountId);
  }

  return `/reports/accounts/ledger?${params.toString()}`;
};

